import keyMirror from 'keymirror';

export default keyMirror({
  RECEIVE_PLANS: null,
  RECEIVE_PLANS_ERROR: null
});